import React, { useId, useState } from "react";
import cx from "classnames";

import styles from "./Marketplace.module.css";
import { track, EVENTS } from "../../utils/analyticsService";
import { MIN_REQUEST_LENGTH, normaliseQuery, reportDemand } from "../../utils/demandCapture";

/**
 * "Can't find it? Tell us which brand" under an empty search. Prefilled with
 * what was searched; sends a brand_request and thanks the person whether or
 * not the request reached the backend (it fails silently).
 */
export const BrandRequest = ({ query, sent, onSent }) => {
  const [value, setValue] = useState(query || "");
  const [sending, setSending] = useState(false);
  const inputId = useId();

  if (sent) {
    return (
      <div className={styles.brandRequest} role="status">
        <div className={styles.brandRequestThanks}>
          Thanks, we've noted it. The more people ask for a brand, the sooner we add it.
        </div>
      </div>
    );
  }

  const tooShort = normaliseQuery(value).length < MIN_REQUEST_LENGTH;

  const submit = async (e) => {
    e.preventDefault();
    if (tooShort || sending) return;
    setSending(true);
    // Length only: a typed brand can carry personal data. The name itself
    // goes to the backend, which scrubs it.
    track(EVENTS.BRAND_REQUESTED, { query_length: value.trim().length, context: "marketplace_empty" });
    await reportDemand("brand_request", value);
    setSending(false);
    onSent(value);
  };

  return (
    <form className={styles.brandRequest} onSubmit={submit}>
      <label className={styles.brandRequestLabel} htmlFor={inputId}>
        Can't find it? Tell us which brand
      </label>
      <div className={styles.brandRequestRow}>
        <input
          id={inputId}
          className={styles.brandRequestInput}
          value={value}
          maxLength={120}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Brand name"
          autoComplete="off"
        />
        <button
          type="submit"
          className={cx(styles.btn, styles.btnSm, styles.btnInk)}
          disabled={tooShort || sending}
        >
          Send
        </button>
      </div>
    </form>
  );
};

export default BrandRequest;
